var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { HistoryActions } from 'app/stores/history/actions';
import { parseImageData } from 'app/stores/image/actions/parse';
import { ProjectActions } from 'app/stores/project/actions';
import { createPage } from 'app/stores/project/page';
import { isSupportedDataSource } from 'app/utils/upload';
export const loadImageFile = createAsyncThunk('image/loadFile', (params, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    const { data, source } = params;
    if (!isSupportedDataSource(data)) {
        throw new Error('Invalid source');
    }
    yield dispatch(ProjectActions.createFromImageData({ data, source }));
}));
export const loadImageFiles = createAsyncThunk('image/loadFiles', (params, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    const { files } = params;
    const supportedFiles = files.filter(isSupportedDataSource);
    if (!supportedFiles) {
        throw new Error('Missing files');
    }
    if (supportedFiles.length === 1) {
        dispatch(loadImageFile({ data: supportedFiles[0], source: 'file' }));
        return;
    }
    // parse images
    const images = [];
    for (let i = 0; i < files.length; i += 1) {
        const file = files[i];
        // We need to process file after file because
        // 1. we want to limit a number of processor workers
        // 2. file processing can be resource consuming
        // eslint-disable-next-line no-await-in-loop
        const image = yield dispatch(parseImageData({
            data: file,
            source: 'file',
            userFeedback: {
                message: `Reading image file ${i + 1}/${files.length}`,
                memo: `${file.name}`,
            },
        })).unwrap();
        images.push(image);
    }
    // add pages
    const pages = images.map(image => [createPage({ image: image.id }), image]);
    pages.forEach(([page, image]) => {
        dispatch(ProjectActions.addImage({ image }));
        dispatch(ProjectActions.addPage({ page }));
    });
    // select first page
    const [page] = pages[0];
    yield dispatch(ProjectActions.selectPage(page.id));
    // reset history (!??)
    dispatch(HistoryActions.clear());
}));
